<template>
  <div class="af-root">
    <Banner></Banner>
    <ShopifyPage />
    <BaseSpinnerBig v-if="!$route.matched.length" />
    <router-view></router-view>
    <ModalContainer />
  </div>
</template>
<script>
  import ModalContainer from '@/components/modals/ModalContainer'
  import Banner from '@/components/Banner'
  import ShopifyPage from '@/components/ShopifyPage'

  export default {
    components: {
      ModalContainer,
      Banner,
      ShopifyPage
    },
    metaInfo () {
      return {
        title: 'Airfields Shopify',
        // Note: shopify-api-key meta and app-bridge.js script are now in index.ejs
        // to ensure App Bridge loads before any other scripts (Shopify requirement)
        htmlAttrs: {
          lang: 'en-US'
        },
        link: [
          //{ rel: 'icon', type: 'image/png', href: '/assets/images/logo_new.png' }
        ]
      }
    },
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/root.vue